import searchDomains from '@/redux/slices/domains/thunks/searchDomains';
import bulkSearchDomains from '@/redux/slices/domains/thunks/bulkSearchDomains';

const thunks = [searchDomains, bulkSearchDomains];

export default thunks;
